import {Button, Checkbox, Form, Input, Modal, Select, Typography} from "antd";
import {useRef, useState} from "react";
import ApiService from "../services/ApiService";
import {useHistory} from "react-router-dom";
import CountryList from "../services/CountryList";
import USStateList from "../services/USStateList";
import EulaText from "../components/EulaText";

export default function Register() {
    const form = useRef();
    const history = useHistory();
    const [wait, setWait] = useState(false)
    const [country, setCountry] = useState('')
    const [eula, setEULA] = useState(false)

    const onFinish = async () => {
        const data = form.current.getFieldsValue();
        if(data) {
            setWait(true)
            const res = await ApiService.Auth.Register(data);
            setWait(false)
            if(res.success) {
                // history.push(`/app/register/success`)
                history.push(`/app/register/verification`)
            }
        }
    }

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                <div style={{width: '50%', display: 'flex', alignItems: 'center', minHeight: 500, minWidth: 1000}}>
                    <div style={{flex: 1, backgroundColor: '#035781', height: '100%', width: '100%', display: 'flex', alignItems: 'center'}}>
                        <div style={{width: '100%', display: "flex", alignItems: 'center', flexDirection: 'column'}}>
                            <img src={'/LogoB41.png'} width={256} height={256}/>
                        </div>
                    </div>
                    <div style={{flex: 1, height: '100%', backgroundColor: '#fff', display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '10%', marginRight: '10%', marginTop: 16}}>
                            <Typography.Title level={2} style={{marginBottom: 4}}>
                                Sign Up
                            </Typography.Title>
                            <br/>
                            <Form
                                ref={form}
                                layout={'vertical'}
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    required={false}
                                    name="email"
                                    label={(<span style={{fontSize: '13pt'}}>E-mail</span>)}
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'The input is not valid E-mail!',
                                        },
                                        {
                                            required: true,
                                            message: 'Please input your E-mail!',
                                        },
                                    ]}
                                >
                                    <Input style={{width: '100%', fontSize: '13pt'}} />
                                </Form.Item>

                                <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name={'name'}
                                        label={(<span style={{fontSize: '13pt'}}>Name</span>)}
                                        rules={[{required: true, min: 3}]}
                                    >
                                        <Input style={{fontSize: '13pt'}}/>
                                    </Form.Item>

                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name={'lastname'}
                                        label={(<span style={{fontSize: '13pt'}}>Lastname</span>)}
                                        rules={[{required: true, min: 3}]}
                                    >
                                        <Input  style={{fontSize: '13pt'}}/>
                                    </Form.Item>
                                </div>

                                <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name="password"
                                        label={(<span style={{fontSize: '13pt'}}>Password</span>)}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your password!',
                                                min: 6
                                            },
                                        ]}
                                        hasFeedback
                                    >
                                        <Input.Password style={{fontSize: '13pt'}} />
                                    </Form.Item>

                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name="password2"
                                        label={(<span style={{fontSize: '13pt'}}>Confirm Password</span>)}
                                        dependencies={['password']}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please confirm your password!',
                                                min: 6
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password style={{fontSize: '13pt'}} />
                                    </Form.Item>
                                </div>

                                <Form.Item
                                    required={false}
                                    style={{flex: 1}}
                                    name={'company'}
                                    label={(<span style={{fontSize: '13pt'}}>Company</span>)}
                                    rules={[{required: true, min: 3}]}
                                >
                                    <Input  style={{fontSize: '13pt'}}/>
                                </Form.Item>

                                <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name={'city'}
                                        label={(<span style={{fontSize: '13pt'}}>City</span>)}
                                        rules={[{required: true, min: 3}]}
                                    >
                                        <Input  style={{fontSize: '13pt'}}/>
                                    </Form.Item>
                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name={'state'}
                                        label={(<span style={{fontSize: '13pt'}}>State</span>)}
                                        rules={[{required: true}]}
                                    >
                                        {
                                            country === 'United States'
                                                ? (
                                                    <Select
                                                        showSearch={true}
                                                        filterOption={(inputValue, option) => {
                                                            return option.value.toLowerCase().includes(inputValue.toLocaleLowerCase())
                                                        }}
                                                    >
                                                        {
                                                            USStateList.map(c => (
                                                                <Select.Option value={c.name}>
                                                                    {c.name}
                                                                </Select.Option>
                                                            ))
                                                        }
                                                    </Select>
                                                )
                                                : (
                                                    <Input style={{fontSize: '13pt'}} />
                                                )
                                        }

                                    </Form.Item>
                                    <Form.Item
                                        required={false}
                                        style={{flex: 1}}
                                        name={'country'}
                                        label={(<span style={{fontSize: '13pt'}}>Country</span>)}
                                        rules={[{required: true, min: 3}]}
                                    >
                                        <Select
                                            style={{height: 38}}
                                            onChange={(value, option) => {setCountry(value)}}
                                            showSearch={true}
                                            filterOption={(inputValue, option) => {
                                                return option.value.toLowerCase().includes(inputValue.toLocaleLowerCase())
                                            }}
                                        >
                                            {
                                                CountryList.map(c => (
                                                    <Select.Option value={c.name}>
                                                        <div style={{fontSize: '13pt'}}>{c.name}</div>
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>

                                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                    <Form.Item
                                        name="eula"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                validator: (_, value) =>
                                                    value ? Promise.resolve() : Promise.reject(new Error('Should accept agreement')),
                                            },
                                        ]}
                                    >
                                        <Checkbox />
                                    </Form.Item>
                                    <Form.Item>
                                        <span style={{fontSize: '13pt'}}>
                                            I have read the <a onClick={() => {setEULA(true)}}>agreement</a>
                                        </span>
                                    </Form.Item>
                                </div>

                                <Form.Item>
                                    <Button type={'primary'} htmlType={'submit'} loading={wait} size={'large'}>
                                        <div style={{fontSize: '13pt', paddingBottom: 8}}>
                                            <div style={{marginTop: -2}}>
                                                Register
                                            </div>
                                        </div>
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                onCancel={() => {setEULA(false)}}
                width={'22cm'}
                open={eula}
                footer={[]}
            >
                <div style={{backgroundColor: '#fff', margin: 24, height: 400, overflowY: 'auto'}}>
                    <EulaText />
                    <Checkbox
                        onChange={(e) => {
                            setTimeout(() => {
                                setEULA(false)
                                form.current.setFieldsValue({
                                    eula: e.target.checked
                                })
                            }, 200)
                        }}
                    >
                        I agree
                    </Checkbox>
                </div>
            </Modal>
        </>
    )
}